// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dialogContent_M_CiW {
    max-height: 80vh;
    max-height: var( --size-dialogMaxHeight, 80vh );
    max-width: 80vw;
    max-width: var( --size-dialogMaxWidth, 80vw );
}`, "",{"version":3,"sources":["webpack://./../../node_modules/@leverege/ui-elements/lib/esm/Dialog.css"],"names":[],"mappings":"AAAA;IACI,gBAA+C;IAA/C,+CAA+C;IAC/C,eAA6C;IAA7C,6CAA6C;AACjD","sourcesContent":[".dialogContent {\n    max-height: var( --size-dialogMaxHeight, 80vh );\n    max-width: var( --size-dialogMaxWidth, 80vw );\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"dialogContent": `dialogContent_M_CiW`
};
export default ___CSS_LOADER_EXPORT___;
